import { translate } from '@optimusgps/optimus-intl';
import { message } from 'antd';
import { AxiosResponseHeaders } from 'axios';
import copy from 'copy-to-clipboard';
import { ROLES } from '../constants/global';
import { CopyToClipBoard, ValidateMultimedia } from './utilities.type';

// export const minimunValidationForMultimedia = ({
// 	roles,
// 	shared = false,
// 	isImpersonating = false,
// }: ValidateMultimedia): boolean =>
// 	!isImpersonating && !shared && (roles.includes(ROLES.VIDEO_CAMERA) || roles.includes(ROLES.CUSTOMER_SUPPORT));

export const shouldDisplayMultimediaIcons = ({
	roles,
	shared = false,
	isImpersonating = false,
	impersonatorRoles = [],
}: ValidateMultimedia): boolean => {
	if (shared) {
		return false;
	}
	if (isImpersonating) {
		return (
			roles.includes(ROLES.VIDEO_CAMERA) &&
			(impersonatorRoles.includes(ROLES.CUSTOMER_SUPPORT) ||
				impersonatorRoles.includes(ROLES.SERVICE_PROVIDER) ||
				impersonatorRoles.includes(ROLES.MASTER))
		);
	}
	return roles.includes(ROLES.VIDEO_CAMERA);
};

export const shouldPlayMultimediaVideos = ({
	roles,
	shared = false,
	isImpersonating = false,
}: ValidateMultimedia): boolean => !shared && !isImpersonating && roles.includes(ROLES.VIDEO_CAMERA);

export const capitilizeFirstLetter = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);

export const copyToClipBoard = ({ text, intl, successMessage, errorMessage }: CopyToClipBoard) => {
	if (copy(text)) {
		if (successMessage) {
			message.success(successMessage);
		} else {
			message.success(intl.formatMessage(translate('successCopy')));
		}
	} else {
		if (successMessage) {
			message.error(errorMessage);
		} else {
			message.error(intl.formatMessage(translate('badCopy')));
		}
	}
};

export const getIntlEventMessageDescriptor = (eventId?: number) => {
	let eventKey = 'unknownEvent';
	if (eventId) {
		eventKey = `event${eventId}`;
	}
	return translate(eventKey);
};

export const downloadFile = (url: string, headers: AxiosResponseHeaders) => {
	const contentDisposition = headers['content-disposition'];
	const link = document.createElement('a');
	link.href = url;
	link.download = contentDisposition.split('filename=')[1].split(';')[0].replace(/['"]/g, '');
	document.body.appendChild(link);
	link.click();
};
